import React, { useRef, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import { CloseIcon, CloseIconWrapper, SearchFilter, StyledInput } from './SearchInput.styles';
import { triggerHaptic } from '../../utils/telegram';

const SearchInput = ({ searchValue, onSearchChange }) => {
  const inputRef = useRef();
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);

  return (
    <SearchFilter
      $expanded={isSearchExpanded}
      onClick={() => {
        triggerHaptic();
      }}>
      {isSearchExpanded ? (
        <CloseIconWrapper
          onClick={() => {
            if (!isSearchExpanded) {
              inputRef.current.focus();
            }
            setIsSearchExpanded(!isSearchExpanded);
            onSearchChange('');
          }}
          $expanded={isSearchExpanded}>
          <CloseIcon />
        </CloseIconWrapper>
      ) : (
        <SearchIcon style={{ minWidth: '20px', position: 'absolute' }} />
      )}
      <StyledInput
        ref={inputRef}
        value={searchValue}
        onBlur={() => {
          if (!searchValue) {
            setIsSearchExpanded(false);
          }
        }}
        placeholder="name or username"
        onFocus={() => {
          setIsSearchExpanded(true);
        }}
        onChange={e => onSearchChange(e.target.value)}
      />
    </SearchFilter>
  );
};

export default SearchInput;
